import { utils, write } from 'xlsx';


type CellData = string | number | boolean | null | undefined;

export function tableToXlsx(table: CellData[][]): Blob {
    console.log('Converting table to XLSX format');
    const worksheet = utils.aoa_to_sheet(table);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const buffer = write(workbook, { bookType: 'xlsx', type: 'array' });
    return new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
}
